import api from "./api";

export async function fetchAttemptedQuizList(params = {}) {
  const response = await api.get("/quiz/attempted-quiz-list", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
